define(function(require, exports, module) {
    var goTop = {
        f: [],
        init: function() {
            var self = this;
            self.render();
            self.handleGoTop();

            if (self.isScroll()) {
                $("#goTop").removeClass("hide");
            }

        },
        render: function() {
            var goTopDiv = $('<div id="goTop" class="hide"></div>');
            $(".viewport").append(goTopDiv);
        },
        handleGoTop: function() {
            var self = this;
            $("#goTop").on("tap", function() {
                document.body.scrollTop = 0;
                $("#goTop").addClass("hide");
            });
            if(typeof(jQuery) != "undefined") {
                jQuery.noConflict();
            }
            $("body").on("touchstart", function(e) {
                self.f.startX = e.touches[0].clientX;
                self.f.endX = e.touches[0].clientX;
                self.f.prevX = self.f.startX;
                self.f.prevY = e.touches[0].clientY;
            }).on("touchend", function(e) {
                setTimeout(function() {
                    if (document.body.scrollTop <= 0) {
                        $("#goTop").addClass("hide");
                    } else {
                        $("#goTop").removeClass("hide");
                    }
                }, 400);

            }).on("touchcancel", function(e) {
                setTimeout(function() {
                    if (document.body.scrollTop <= 0) {
                        $("#goTop").addClass("hide");
                    } else {
                        $("#goTop").removeClass("hide");
                    }
                }, 400);
            });
        },
        isScroll: function() {
            if (document.body.scrollTop > 0) {
                return true;
            } else {
                return false;
            }
        }
    };
    exports.fn = goTop;
});



// WEBPACK FOOTER //
// ./src/js/unit/goTop/goTop.js